<div class="page-container">
  <app-carousel-wrapper [carouselItems]="homeCarouselItems"></app-carousel-wrapper>
  <app-flat-map-section></app-flat-map-section>

  <div class="articles container">
    <app-section-heading [label]="'Hírek'"></app-section-heading>
    <div class="row">
      <div class="col-12 col-md-8" [class.col-md-12]="!highlightedArticle">
        <article-preview [article]="article"
                         *ngFor="let article of filteredArticles |  sort: 'createdAt' : true"></article-preview>
      </div>

      <div class="col-12" [ngStyle]="{'padding-right': 0}">
        <div class="more-news" (click)="openArticlesPage()">
          <mat-icon class="dark" matSuffix>{{'arrow_forward_ios'}}</mat-icon>
          TOVÁBBI HÍREK
        </div>
      </div>
    </div>
  </div>

  <div class="advantages-wrapper">
    <app-adventages-section></app-adventages-section>
  </div>


  <div class="general-information-wrapper">
    <app-general-information></app-general-information>
  </div>

  <div class="map-wrapper">
    <app-projects-map></app-projects-map>
  </div>

  <div class="contact-wrapper">
    <app-contact-section></app-contact-section>
  </div>


</div>
